import { addTime, isBefore, isAfter, timeDiff, time } from './helper';
export var getAllSlots = function (start, end, interval, unit) {
    if (start === void 0) { start = time(0, 30); }
    if (end === void 0) { end = time(23, 30); }
    if (interval === void 0) { interval = 30; }
    var slots = [];
    if (timeDiff(start, end) !== 0 && isAfter(end, start))
        slots.push(start);
    var newSlot = addTime(start, interval, unit ? unit : 'm');
    while (isBefore(newSlot, end)) {
        slots.push(newSlot);
        newSlot = addTime(newSlot, interval, unit ? unit : 'm');
    }
    return slots;
};
export var getNearSlots = function (timeSlots, bias, interval, unit) {
    var newStart = addTime(bias, -interval, unit ? unit : 'm');
    var newEnd = addTime(bias, interval, unit ? unit : 'm');
    return timeSlots.filter(function (slot) {
        var isBias = timeDiff(slot, bias, 'm') === 0;
        var includeStart = timeDiff(slot, newStart, 'm') === 0;
        var includeEnd = timeDiff(slot, newEnd, 'm') === 0;
        return slot && (includeStart || isBefore(newStart, slot)) && (includeEnd || (isAfter(newEnd, slot) && !isBias));
    });
};
//# sourceMappingURL=timeSlot.js.map